import { DealershipSendSmsComponent } from '../../app-lite/dealership/dealership.send-sms.component';

export function DealershipService (
  $uibModal,
  $q,
  $translate,
  confirm,
  messengerApi,
  sessionObjAPI,
  workshopAPI
) {
  var Dealership = function (dealership) {
    this.messengerApi = messengerApi;

    this.acquisition_product_id    = dealership.acquisition_product_id;
    this.acquisition_product_name  = dealership.acquisition_product_name;
    this.id                        = dealership.id;
    this.internal_customer_id      = dealership.internal_customer_id;
    this.internal_customer_name    = dealership.internal_customer_name;
    this.internal_invoice_id       = dealership.internal_invoice_id;
    this.trade_in_product_id       = dealership.trade_in_product_id;
    this.trade_in_product_name     = dealership.trade_in_product_name;
    this.vehicle_sale_product_id   = dealership.vehicle_sale_product_id;
    this.vehicle_sale_product_name = dealership.vehicle_sale_product_name;
    this.motor_dealer_license_number = dealership.motor_dealer_license_number;
    this.advertising_settings = {
      bikesales_password          : dealership.bikesales_password,
      bikesales_username          : dealership.bikesales_username,
      boatsales_password          : dealership.boatsales_password,
      boatsales_username          : dealership.boatsales_username,
      caravancampingsales_password: dealership.caravancampingsales_password,
      caravancampingsales_username: dealership.caravancampingsales_username,
      carsales_password           : dealership.carsales_password,
      carsales_username           : dealership.carsales_username,
      constructionsales_password  : dealership.constructionsales_password,
      constructionsales_username  : dealership.constructionsales_username,
      farmmachinerysales_password : dealership.farmmachinerysales_password,
      farmmachinerysales_username : dealership.farmmachinerysales_username,
      has_bike_sales              : dealership.has_bike_sales,
      has_boat_sales              : dealership.has_boat_sales,
      has_car_sales               : dealership.has_car_sales,
      has_caravan_camping_sales   : dealership.has_caravan_camping_sales,
      has_construction_sales      : dealership.has_construction_sales,
      has_farm_machinery_sales    : dealership.has_farm_machinery_sales,
      has_truck_sales             : dealership.has_truck_sales,
      trucksales_password         : dealership.trucksales_password,
      trucksales_username         : dealership.trucksales_username
    };
  };

  Dealership.prototype.activate = function () {
    return confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', { name: 'Dealership' }))
    .then(() => workshopAPI.get('/company/add_dealership'))
    .then(() => sessionObjAPI.refresh())
    .catch(error => error);
  };

  Dealership.prototype.deactivate = function () {
    return confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.DEACTIVATE', { name: 'Dealership' }))
    .then(() => workshopAPI.get('/company/remove_dealership'))
    .then(() => sessionObjAPI.refresh())
    .catch(error => error);
  };

  Dealership.prototype.save = function () {
    var self = this;

    return workshopAPI.patch('/dealership_setting', self, 'dealership_setting');
  };

  Dealership.prototype.saveAdvertisingSettings = function () {
    var self = this;

    return workshopAPI.patch('/dealership_advertising_setting', self.advertising_settings, 'dealership_advertising_setting');
  };

  Dealership.prototype.sendSMS = function (id) {
    const self = this;

    return self.messengerApi.sms({
      message: `${sessionObjAPI.base().origin}vehicle.html#/vehicle/${id}`,
      name   : '',
      send_to: ''
    }, {
      factory: DealershipSendSmsComponent
    });
  };

  Dealership.prototype.sendEmail = function (id) {
    const self = this;

    return self.messengerApi.email({
      attachment_type: 4,
      body           : `${sessionObjAPI.base().origin}vehicle.html#/vehicle/${id}`,
      email_address  : '',
      name           : $translate.instant('DEALERSHIP_SPACE.VEHICLE_FOR_SALE'),
      subject        : `Vehicle for Sale from ${ sessionObjAPI.company().company_name }`
    }, {
      templateKey: 'unit'
    });
  };

  return Dealership;
};